<template>
	<div class="indicator_blood_pressure">
		<div class="px-32">
			<IndicatorBase :list="labelBase" :record-date="lastRecord.measureTime" :status="lastRecord.status" />
			<div class="indicator_blood_content">
				<van-tabs v-model="dateType" color="#1F2329">
					<van-tab :name="1" title="日"></van-tab>
					<van-tab :name="2" title="周"></van-tab>
					<van-tab :name="3" title="月"></van-tab>
				</van-tabs>
				<indicatorReportTitle
					title="血压趋势"
					:label="dateDesc"
					@labelSelect="selectTime"
					:textType="typeList"
				/>
				<IndicatorChart ref="chart" />
			</div>
		</div>

		<IndicatorTable
			class="mt-28"
			:loading.sync="loading"
			:list="list"
			:finished="true"
			@more="
                $router.push(
                    `/indicator/bloodPressure/hostory/list?previewType=${previewType}&patientId=${patientId}`
                )
            "
			@load="getList"
			@onUpdate="clickEdit"
		/>
		<foot-button v-if="previewType !== 'doctor'">
			<van-button type="primary" block @click="selectEdit('hand')">记录血压</van-button>
		</foot-button>
		<van-popup v-model="showSelectDateTime" position="bottom" round>
			<van-datetime-picker
				v-model="currentDate"
				:type="datetimeType"
				title="选择日期"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="confirmTime"
				@cancel="showSelectDateTime = false"
			/>
		</van-popup>
		<van-popup v-model="showSelectWeek" round position="bottom">
			<van-picker
				show-toolbar
				ref="picker"
				:columns="columns"
				@cancel="showSelectWeek = false"
				@confirm="confirmTime"
				@change="onChange"
			>
				<template #option="option">
					<div class="week_picke_style" v-if="option.type === 'week'">
						<div class="title">
							{{ weekObj[option.number] }}
						</div>
						<div class="label">
							{{$moment(option.value).startOf('isoWeek').format('MM.DD')}}
							-
							{{$moment(option.value).endOf('isoWeek').format('MM.DD')}}
						</div>
					</div>
					<div v-else class="picke_style">
						{{ option.value }}
					</div>
				</template>
			</van-picker>
		</van-popup>
	</div>
</template>

<script>
import IndicatorBase from './components/indicator-base.vue'
import IndicatorChart from './components/indicator-chart.vue'
import IndicatorTable from './components/history-list.vue'
import MixinList from './mixins/list'
import indicatorReportTitle from './components/indicator-report-title.vue'

export default {
    name: 'indicatorBloodPressure',
    components: {
        IndicatorBase,
        IndicatorTable,
        indicatorReportTitle,
        IndicatorChart
    },
    mixins: [MixinList],
    data: () => ({
        labelBase: [],
        editUrl: '/indicator/bloodPressure/edit',
        date: new Date(),
        dateType: 1,
        typeList: [
            { color: '#4CBC84', label: '收缩压（高压）' },
            { color: '#5285f4', label: '舒张压（低压）' }
        ]
    }),
    computed: {
    },
    methods: {
        async load () {
            const lastInfo = await this.$api.indicator.bloodPressureLastInfo({
                patientId: this.patientId,
                date: this.$moment().format('YYYY-MM-DD')
            })
            if (!lastInfo.code) {
                const { bloodPressureInfo } = lastInfo.data
                this.handleLastRecord(bloodPressureInfo || {})
                this.getDetail()
            }
            await this.getList()
        },

        // 最近一次记录的逻辑处理
        handleLastRecord (record = {}) {
            if (record.measureTime) { record.measureTime = this.$utils.substrLastIndex(record.measureTime, ':', true) } else { record.measureTime = '您还没有上传血压记录' }

            this.labelBase = [
                { value: `${record.highPressure || '--'}`, unit: 'mmHg', label: '收缩压（高压）' },
                { value: `${record.lowPressure || '--'}`, unit: 'mmHg', label: '舒张压（低压）' },
            ]

            record.status = this.$status.bloodStatus[Math.max(record.lowPressureStatus, record.highPressureStatus)]

            this.lastRecord = record
        },

        // 获取历史记录
        async getList () {
            this.loading = true
            const res = await this.$api.indicator.bloodpressurePage({
                patientId: this.patientId,
                page: this.page,
                limit: 5
            })
            this.loading = false
            if (!res.code) {
                let arr = res.data.list.map(v => ({
                    ...v,
                    list: [{
                        number: `${v.highPressure}/${v.lowPressure}`,
                        unit: 'mmHg',
                        status: this.$status.bloodStatus[Math.max(v.lowPressureStatus, v.highPressureStatus)],
                    }],
                    time: this.$moment(v.measureTime).format('HH:mm'),

                }))
                this.list = this.initList(this.list, arr)
                this.total = res.data.total
                this.page++
            }
        },
        selectEdit (type) {
            if (type === 'hand') {
                this.clickCreate()
            }
        },
        getDetail () {
            let measureTime = this.$moment(this.sunData).format('YYYY-MM-DD 00:00:00')
            this.$api.indicator.getBloodpressureCharts({
                patientId: this.patientId,
                measureTime,
                dateType: this.dateType,
            }).then(({ code, data }) => {
                if (!code) {
                    // 格式化图表数据
                    let xAxis = []
                    let sbpData = []
                    let dbpData = []
                    data && data.forEach(v => {
                        let time = this.$moment(v.measureTime).format(this.dateType === 1 ? 'HH:mm' : 'MM-DD')
                        xAxis.push(time)
                        sbpData.push(v.highPressure)
                        dbpData.push(v.lowPressure)
                    })
                    this.xAxis = xAxis
                    // 渲染图表
                    this.$nextTick(() => {
                        this.$refs.chart.start({
                            markArea: {
                                itemStyle: {
                                    color: 'rgba(31, 35, 41, 0.1)'
                                },
                                data: []
                            },
                            datas: [
                                { name: '收缩压', color: '#4CBC84', data: sbpData },
                                { name: '舒张压', color: '#5285F4', data: dbpData }
                            ],
                            xAxis
                        })
                    })
                }
            })
        }

    }
}
</script>

<style scoped lang="less">
.indicator_blood_pressure {
	min-height: calc(100vh - 216px);
	padding: 40px 0;
}
.time_slot_blood_pressure {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
}
.time_slot_blood_pressure_header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 34px;
	color: #000000;
	font-weight: 500;
	span {
		color: @gray-9;
		font-size: 26px;
		font-weight: 400;
	}
}

.indicator_blood_content {
	border-radius: 16px;
	background-color: #ffffff;
	overflow: hidden;
	margin-top: 28px;
	padding: 0 32px 40px 32px;
}
.picke_style {
	font-size: 40px;
	color: #14161a;
}
.week_picke_style {
	text-align: center;
	.title {
		font-size: 28px;
		color: #14161a;
	}
	.label {
		color: @gray-9;
		font-size: 22px;
	}
}
</style>
